import React from 'react'
import { Col, OverlayTrigger, Placeholder, Tooltip } from 'react-bootstrap'
import { mixpanelInstance } from '@mixpanel/instance'
import IntervalAuctionPlacements from './IntervalAuctionPlacements'
import { ppc_modal_labels } from '@revbox/localization'

function PPCModalPlacements({ inventoryCampaign, campaignId, language, auctionType, isContentAd }) {
    const { inventory, directory_placement, magazine_placement, related_categories } = inventoryCampaign || {}

    const hasInventoryUrl = !!inventory?.url
    const hasDirectoryPlacement = !!inventory && !!directory_placement
    const hasMagazinePlacement = !!inventory && !!magazine_placement
    const intervalAuction = auctionType === 'interval'
    const placementLabel = ppc_modal_labels[language].placement
    const isClusterInventory = !!inventory && inventory.inventory_type === 5

    return (
        <Col
            sm="12"
            className="text-left"
            onClick={() =>
                mixpanelInstance.track('Placement 1 button clicked in bid management popup', {
                    campaignId
                })
            }
        >
            {!inventoryCampaign && (
                <div className="d-flex align-items-center">
                    <Placeholder animation="glow">
                        <Placeholder style={{ height: 20, width: '100px' }} />
                    </Placeholder>
                    <Placeholder animation="glow">
                        <Placeholder style={{ height: 20, width: '100px', marginLeft: 10 }} />
                    </Placeholder>
                </div>
            )}
            {/* TODO: update for HTR too */}

            {hasDirectoryPlacement && (
                <a href={directory_placement} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary me-1">
                    {ppc_modal_labels[language].directory}
                    <i className="ri-external-link-line" style={{ marginLeft: '5px' }}></i>
                </a>
            )}

            {hasMagazinePlacement && (
                <a href={magazine_placement} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary me-1">
                    {ppc_modal_labels[language].magazine}
                    <i className="ri-external-link-line" style={{ marginLeft: '5px' }}></i>
                </a>
            )}

            {!intervalAuction && !isClusterInventory &&
                related_categories?.length > 0 &&
                related_categories.map((category, index) => {
                    return (
                        <OverlayTrigger placement="bottom" overlay={<Tooltip placement="bottom">{category.name}</Tooltip>}>
                            <a href={category.url} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary me-1">
                                {placementLabel} {index + 1}
                                <i className="ri-external-link-line" style={{ marginLeft: '5px' }}></i>
                            </a>
                        </OverlayTrigger>
                    )
                })}

            {hasInventoryUrl && intervalAuction && <IntervalAuctionPlacements inventoryCampaign={inventoryCampaign} label={placementLabel} />}
        </Col>
    )
}

export default PPCModalPlacements
